import Coverages from './Coverages';

export default Coverages